import {Icon} from '@wandb/components';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {type FC} from 'react';

import {createDismissibleBanner} from '../../../pages/Billing/AccountSettings/WarningBanner/DismissibleBanner';
import {useViewer} from '../../../state/viewer/hooks';
import {Banner, BannerFlexWrapper, BannerTextWrapper} from '../../Banner';

const NVIDIA_LINK_CUTOFF_DATE = new Date('2026-03-20T00:00:00Z');
const BANNER_ID = 'nvidia-linked-account-notice';

type NvidiaLinkedAccountBannerProps = {
  linkedDate: string;
};

const NvidiaLinkedAccountNoticeBanner =
  createDismissibleBanner<NvidiaLinkedAccountBannerProps>({
    id: () => BANNER_ID,
    Component: ({linkedDate, onDismiss}) => {
      return (
        <Tailwind>
          <Banner variant="info" className="mb-4">
            <BannerFlexWrapper>
              <Icon icon="info" />
              <BannerTextWrapper>
                <span>
                  On {linkedDate}, you opted in to sharing usage data with
                  NVIDIA. By continuing to use this account, you confirm that
                  you're OK with this. If you'd like to opt out, you can unlink
                  your NVIDIA account in your user settings.
                </span>
              </BannerTextWrapper>
            </BannerFlexWrapper>
            <button
              className="flex items-center border-none bg-transparent font-semibold text-moon-600 hover:cursor-pointer hover:text-moon-900"
              onClick={onDismiss}>
              OK
            </button>
          </Banner>
        </Tailwind>
      );
    },
  });

export const NvidiaLinkedAccountBannerGlobal: FC = () => {
  const viewer = useViewer();
  if (viewer == null) {
    return null;
  }

  const {nvidiaAccountLinkedAt} = viewer;
  if (!nvidiaAccountLinkedAt) {
    return null;
  }

  const linkedAt = new Date(nvidiaAccountLinkedAt);
  if (linkedAt >= NVIDIA_LINK_CUTOFF_DATE) {
    return null;
  }

  const linkedDate = linkedAt.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return <NvidiaLinkedAccountNoticeBanner linkedDate={linkedDate} />;
};
